import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

export const FashionCard = ({ imageUrl, label, link }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      component={Link}
      to={link}
      sx={{ display: "block", textDecoration: "none" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Box sx={{ overflow: "hidden", aspectRatio: { xs: "4/5", md: "3/4" } }}>
        <img
          src={imageUrl}
          alt={label}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            transition: "transform 0.55s ease",
            transform: hovered ? "scale(1.05)" : "scale(1)",
          }}
        />
      </Box>
      <Box sx={{ pt: 2 }}>
        <Typography
          sx={{
            fontSize: { xs: 13, md: 14 },
            fontWeight: 500,
            letterSpacing: "0.07em",
            textTransform: "uppercase",
            color: "#111827",
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            letterSpacing: "0.05em",
            mt: 0.75,
            display: "inline-block",
            borderBottom: "1px solid",
            pb: 0.25,
            color: hovered ? "#111827" : "#6b7280",
            borderColor: hovered ? "#111827" : "#6b7280",
            transition: "color 0.2s, border-color 0.2s",
          }}
        >
          Shop Now
        </Typography>
      </Box>
    </Box>
  );
};
